import ua from '@tencent/docs-user-agent';
import DocsConfig from '@tencent/docs-config';
import { isWordLike, isExcelLike, isPowerPointLike } from '@tencent/docs-mime-types';

const LogPadType = {
    Sheet: 'sheet',
    Backend: 'backend',
    WxJsSdk: 'WxJsSdk',
    Mqq: 'Mqq',
    Fc: 'fc',
    Sc: 'sc',
    Ark: 'ark',
    DC: 'dc',
    Doc: 'doc',
    BlankPage: 'blankPage',
    Slide: 'slide',
    PDF: 'pdf',
    Board: 'board',
    Form: 'form',
    Scenario: 'scenario',
    SmartSheet: 'smartSheet',
};

function getBasicClientVars() {
    return window.basicClientVars;
}
function getClientVars() {
    var _a;
    return (_a = window.clientVars) !== null && _a !== void 0 ? _a : {};
}

function getCookie(key) {
    const reg = new RegExp(`(?:^|;+|\\s+)${key}=([^;]*)`);
    const match = typeof document === 'object' && document.cookie.match(reg);
    return match ? match[1] : null;
}
function setCookie(key, value, hours, domain, path) {
    const expire = new Date();
    expire.setTime(expire.getTime() + (hours ? 60 * 60 * 1000 * hours : 30 * 24 * 60 * 60 * 1000));
    if (typeof document !== 'undefined') {
        document.cookie = `${key}=${value};expires=${expire.toGMTString()};path=${path || '/'};${domain ? (`domain=${domain};`) : ''}`;
    }
}

function getUrlParameter(paramKey) {
    const search = window.location.search.substring(1);
    if (!search) {
        return;
    }
    const kvArray = search.split('&');
    for (const kv of kvArray) {
        const [key, value] = kv.split('=');
        if (key === paramKey) {
            return value;
        }
    }
}
function getURLSearchParam(urlString, key) {
    const url = new URL(urlString);
    return url.searchParams.get(key);
}
(() => {
    const link = typeof document === 'undefined' ? null : document.createElement('a');
    return (url) => {
        if (!link)
            return url;
        link.href = url;
        return link.href;
    };
})();

function getVersionWithName(name, ua = window.navigator.userAgent) {
    try {
        const pattern = new RegExp(`\\b${name}\\/((\\d+\\.){1,3}\\d+)`, 'i');
        const match = pattern.exec(ua);
        return (match && match.length > 1 && match[1]) || '';
    }
    catch (err) {
        return '';
    }
}

const FILE_TYPE_MAP = {
    doc: 1,
    sheet: 2,
    form: 3,
    slide: 4,
    pdf: 7,
    mind: 8,
    flowchart: 9,
    rec: 10,
    smartsheet: 13,
    smartcanvas: 14,
    resume: 15,
    board: 12,
};
const errorNumber = -1;
const booleanToNumber = {
    errorNumber: -1,
    trueNumber: 1,
    falseNumber: 0,
};
var Auth;
(function (Auth) {
    Auth[Auth["error"] = -1] = "error";
    Auth[Auth["owner"] = 0] = "owner";
    Auth[Auth["writer"] = 1] = "writer";
    Auth[Auth["reader"] = 2] = "reader";
})(Auth || (Auth = {}));
var Application;
(function (Application) {
    Application["CLIENT"] = "client";
    Application["MOBILE"] = "mobile";
    Application["WECHAT"] = "wechat";
    Application["BROWSER"] = "browser";
    Application["OTHER"] = "other";
})(Application || (Application = {}));
var Platform;
(function (Platform) {
    Platform["ANDROID"] = "android";
    Platform["iOS"] = "iOS";
    Platform["WIN"] = "win";
    Platform["MAC"] = "mac";
    Platform["Harmony"] = "harmony";
    Platform["OTHER"] = "other";
})(Platform || (Platform = {}));
var Page;
(function (Page) {
    Page["tab_timeline"] = "tab-timeline";
    Page["tab_all"] = "tab-all";
    Page["detail"] = "detail";
    Page["setting_auth"] = "setting-auth";
    Page["template"] = "template";
    Page["error"] = "error";
    Page["activities"] = "activities";
    Page["login"] = "login";
    Page["member"] = "member";
    Page["tab_container"] = "tab-container";
    Page["tab_icon"] = "tab-icon";
    Page["m_setting_auth"] = "m-setting-auth";
    Page["m_detail_menu"] = "m-detail-menu";
    Page["m_tab_all_menu"] = "m-tab-all-menu";
    Page["m_activities"] = "m- activities";
    Page["m_member"] = "m-member";
    Page["m_form_app"] = "m-form-app";
    Page["m_gourp_form_app"] = "m-gourp-form-app";
    Page["m_tab_timeline"] = "m-tab-timeline";
    Page["m_tab_all"] = "m-tab-all";
    Page["m_group_doc"] = "m-group-doc";
})(Page || (Page = {}));
var PadType;
(function (PadType) {
    PadType["Doc"] = "doc";
    PadType["Sheet"] = "sheet";
    PadType["Slide"] = "slide";
    PadType["Form"] = "form";
    PadType["Pdf"] = "pdf";
    PadType["Board"] = "board";
    PadType["Mind"] = "mind";
    PadType["FlowChart"] = "flowchart";
    PadType["Aio"] = "Aio";
    PadType["Folder"] = "folder";
    PadType["SmartSheet"] = "smartsheet";
    PadType["Drive"] = "drive";
})(PadType || (PadType = {}));

function randomStr(length) {
    let temp = '';
    for (let i = 0; i < length; i++) {
        temp += Math.random()
            .toString(36)
            .substr(2);
    }
    return temp;
}

function tdwEscapes(target) {
    return target
        .replace(/&/g, '\\&')
        .replace(/\|/g, '\\|')
        .replace(/=/g, '\\=')
        .replace(/%/g, '\\%')
        .replace(/\r/g, '\\r')
        .replace(/\n/g, '\\n')
        .replace(/\t/g, '\\t');
}

var _a;
const DocsConfigModule = DocsConfig.default || DocsConfig;
const appConfigInstance = DocsConfigModule.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/tencent-doc-report"]') || {};
const LOCATION_HOST = location.host;
const SDK_BUNDLE_URL = npmConfig.SDK_BUNDLE_URL || 'https://docs.gtimg.com/alloy-report-sdk/latest/v4/alloyreport.sdk.js';
const ENT_SDK_BUNDLE_URL = npmConfig.ENT_SDK_BUNDLE_URL || 'https://res.wx.qq.com/d/alloy-report-sdk/latest/v4/alloyreport.sdk.js';
npmConfig.docrpWeixinOrigin || 'https://docrp.weixin.qq.com';
const wecomMainHost = npmConfig.wecomMainHost || 'doc.weixin.qq.com';
const wecomAddonHost = npmConfig.wecomAddonHost || 'wecom-addon.tencentsuite.com';
const cookieDomain = npmConfig.cookieDomain || '.docs.qq.com';
npmConfig.reportIdqqimgOrigin || 'https://report.idqqimg.com';
npmConfig.reportIdqqimgHost || 'report.idqqimg.com';
npmConfig.reportUrlOrigin || 'https://report.url.cn';
npmConfig.reportUrlHost || 'report.url.cn';
npmConfig.reportHuatuoOrigin || 'https://report.huatuo.qq.com';
npmConfig.beaconOrigin || 'https://otheve.beacon.qq.com';
npmConfig.tencentDocCdnGoOrigin || 'https://tencent-doc.cdn-go.cn';
npmConfig.qqwebQQHost || 'qqweb.qq.com';
npmConfig.qunQQHost || 'qun.qq.com';
npmConfig.interceptorIgnoreUrls
    || [
        'report.url.cn',
        'huatuo.qq.com',
        'aegis.qq.com',
        'report.idqqimg.com',
        'galileotelemetry.tencent.com',
    ];
(_a = appConfigInstance.getConfig('runtime.apiRoot')) !== null && _a !== void 0 ? _a : 'docs.qq.com';
!!appConfigInstance.getConfig('wenku.reportToWenku');
appConfigInstance.getConfig('runtime.domainName') || LOCATION_HOST;
const appDomain = appConfigInstance.getConfig('domain');
const isWebOfficePrivate = appDomain === 'weboffice';

const wecomHostNames = [wecomMainHost, wecomAddonHost];
const runtimeIsWeWorkEnv = (function () {
    const isWecomEnv = wecomHostNames.includes((typeof location !== 'undefined' && location.origin.split('//')[1]) || '');
    return () => isWecomEnv;
}());

const getChannel = (userAgent) => {
    const reg = /TDAppDesktopChannel\/[\d]{5}/g;
    const match = userAgent.match(reg);
    return match ? match[0].slice(-5) : null;
};

class ClientInfo {
    get domain() {
        var _a, _b, _c, _d;
        return ((_b = (_a = window.AppConfig) === null || _a === void 0 ? void 0 : _a.normal) === null || _b === void 0 ? void 0 : _b.domain) || ((_d = (_c = window.AppConfig) === null || _c === void 0 ? void 0 : _c.normal) === null || _d === void 0 ? void 0 : _d.instance) || location.host;
    }
    get tenant() {
        var _a, _b, _c, _d;
        if (!((_a = window.clientVars) === null || _a === void 0 ? void 0 : _a.creatorCorpId))
            return '';
        return runtimeIsWeWorkEnv()
            ? `${(_b = window.clientVars) === null || _b === void 0 ? void 0 : _b.creatorCorpId}`
            : `${(_c = window.clientVars) === null || _c === void 0 ? void 0 : _c.creatorCorpName}:${(_d = window.clientVars) === null || _d === void 0 ? void 0 : _d.creatorCorpId}`;
    }
    get client() {
        var _a, _b, _c;
        return (_c = (_b = (_a = window.AppConfig) === null || _a === void 0 ? void 0 : _a.normal) === null || _b === void 0 ? void 0 : _b.client) !== null && _c !== void 0 ? _c : '';
    }
    get platform() {
        if (ua.isIPhone) {
            return 'iPhone';
        }
        if (ua.isIPad) {
            return 'iPad';
        }
        if (ua.isAndroidPad) {
            return 'androidPad';
        }
        if (ua.isAndroidPhone) {
            return 'androidPhone';
        }
        if (ua.isHarmonyPhone) {
            return 'harmonyPhone';
        }
        if (ua.isHarmonyPad) {
            return 'harmonyPad';
        }
        if (ua.isMac) {
            return 'mac';
        }
        if (ua.isWindows) {
            return 'windows';
        }
        return 'other';
    }
    get source() {
        const sourceCheckFlags = [
            [ua.isWxMiniProgram, 'wxMiniProgram'],
            [ua.isQQMiniProgram, 'qqMiniProgram'],
            [ua.isWxWork, 'wxWork'],
            [ua.isChrome, 'chrome'],
            [ua.isSafari, 'safari'],
            [ua.isFirefox, 'firefox'],
            [ua.isChromiumEdge, 'chromiumEdge'],
            [ua.isQQBrowser, 'qqBrowser'],
            [ua.isHarmonyBrowser, 'harmonyBrowser'],
            [ua.isTencentDocsApp, 'tencentDocsApp'],
            [ua.isPCTencentDocsClient, 'pcTencentDocsClient'],
            [ua.isWeiYunApp, 'weiYunApp'],
            [ua.isElectronTencentDocsClient, 'electronTencentDocsClient'],
            [ua.isWeChat, 'weChat'],
            [ua.isQQ, 'qq'],
            [ua.isTim, 'tim'],
            [ua.isWindowsUWP, 'windowsUwp'],
        ];
        for (let i = 0; i < sourceCheckFlags.length; i++) {
            if (sourceCheckFlags[i][0]) {
                return sourceCheckFlags[i][1];
            }
        }
        return '';
    }
    get env() {
        var _a;
        return (_a = window.__DWS_INFO__) === null || _a === void 0 ? void 0 : _a.curEnvId;
    }
}
const clientInfo = new ClientInfo();

const _window = (() => {
    if (typeof window !== 'undefined' && window && window.navigator) {
        return window;
    }
    return null;
})();
const _wx = (() => {
    if (isNativeMiniProgram()) {
        return qq || wx;
    }
    return null;
})();
(() => {
    if (_window && _window.localStorage && typeof _window.localStorage.getItem === 'function') {
        return 1;
    }
    if (isNativeMiniProgram() && typeof _wx.getStorage === 'function') {
        return 2;
    }
    return 0;
})();
function isNativeMiniProgram() {
    if (typeof qq === 'object' && qq.canIUse) {
        return qq.canIUse('request');
    }
    if (typeof wx === 'object' && wx.canIUse) {
        return wx.canIUse('request');
    }
    return false;
}
const isInBrowser = () => typeof document !== 'undefined';

let cacheUin = null;
let cacheUid = null;
let source3Cache = null;
if (isInBrowser()) {
    const version = ua.getWxWorkVersion();
    if (version) {
        `${ua.isWxWorkQt ? 'QT' : ''}${version}`;
    }
}
function getCookieUin() {
    if (cacheUin) {
        return cacheUin;
    }
    const uinInCookie = getCookie('p_luin') || getCookie('p_uin');
    if (uinInCookie) {
        cacheUin = uinInCookie.replace(/^[o0]+/i, '');
    }
    return cacheUin;
}
function getUidFromMulti() {
    var _a;
    return ((_a = window.global_multi_user) === null || _a === void 0 ? void 0 : _a.uid) || null;
}
function getCookieUid() {
    if (cacheUid) {
        return cacheUid;
    }
    const uidInCookie = getCookie('uid') || getCookie('wedrive_uin') || getCookie('tdoc_uid');
    if (uidInCookie) {
        cacheUid = uidInCookie;
    }
    return cacheUid;
}
function getUin() {
    return getCookieUin() || getUinFromClientVars() || getUidForReport();
}
function getUidForReport() {
    return getUidFromMulti() || getCookieUid() || getUidFromClientVars();
}
function getUinFromClientVars() {
    var _a, _b;
    return ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.uin) || getClientVars().uin || null;
}
function getUidFromClientVars() {
    var _a, _b, _c;
    return ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.userId) || ((_c = getClientVars().userInfo) === null || _c === void 0 ? void 0 : _c.uid) || null;
}
function getBrowserStr() {
    var _a;
    try {
        let storageStr = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('browserStr');
        if (!storageStr) {
            storageStr = randomStr(5);
            if (window.localStorage) {
                window.localStorage.setItem('browserStr', storageStr);
            }
        }
        return storageStr;
    }
    catch (error) {
        return randomStr(5);
    }
}
function getSource3() {
    if (source3Cache) {
        return source3Cache;
    }
    const adtag = getUrlParameter('adtag');
    if (adtag) {
        source3Cache = adtag;
        setCookie('adtag', adtag, 24 * 365, cookieDomain, '/');
        localStorage.setItem('tdsourcetag', adtag);
    }
    else {
        const tdsourcetag = getUrlParameter('tdsourcetag');
        if (tdsourcetag) {
            source3Cache = tdsourcetag;
            setCookie('adtag', tdsourcetag, 24 * 365, cookieDomain, '/');
            localStorage.setItem('tdsourcetag', tdsourcetag);
        }
        else {
            const fromPageTag = getUrlParameter('from_page');
            if (fromPageTag) {
                source3Cache = fromPageTag;
                setCookie('adtag', fromPageTag, 24 * 365, cookieDomain, '/');
                localStorage.setItem('tdsourcetag', fromPageTag);
            }
        }
    }
    if (!source3Cache) {
        source3Cache = localStorage.getItem('tdsourcetag') || getCookie('adtag') || '';
    }
    return source3Cache;
}
function getUinTypeForReport() {
    var _a, _b, _c;
    return ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.loginType)
        || ((_c = getClientVars().userInfo) === null || _c === void 0 ? void 0 : _c.loginType)
        || errorNumber;
}
const padTypeMap = {
    flowchart: 'flow',
};
function getFileTypeStrForReport(useTypeMap = false) {
    var _a, _b, _c;
    const padType = ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.padType) || getClientVars().padType;
    if (useTypeMap && padTypeMap[padType]) {
        return padTypeMap[padType];
    }
    return padType;
}
function getFileTypeForReport(rawFileType = '') {
    var _a;
    let fileTypeStr = getFileTypeStrForReport() || rawFileType;
    if (!fileTypeStr) {
        return errorNumber;
    }
    if (fileTypeStr === 'drive') {
        fileTypeStr = handleDriveType();
    }
    return (_a = FILE_TYPE_MAP[fileTypeStr]) !== null && _a !== void 0 ? _a : errorNumber;
}
function handleDriveType() {
    var _a, _b, _c;
    const padType = {
        doc: 'doc',
        sheet: 'sheet',
        slide: 'slide',
    };
    try {
        const mimeType = (_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.mimeType) !== null && _c !== void 0 ? _c : '';
        if (isWordLike(mimeType)) {
            return padType.doc;
        }
        if (isExcelLike(mimeType)) {
            return padType.sheet;
        }
        if (isPowerPointLike(mimeType)) {
            return padType.slide;
        }
        return '';
    }
    catch (error) {
        return '';
    }
}
function getIsOwner() {
    var _a, _b;
    const isOwner = ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.isOwner) || getClientVars().isOwner;
    if (typeof isOwner === 'undefined') {
        return errorNumber;
    }
    return isOwner ? booleanToNumber.trueNumber : booleanToNumber.falseNumber;
}
function getAuth(rightFlag) {
    var _a, _b;
    return rightFlag || ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.authInfo) === null || _b === void 0 ? void 0 : _b.privilegeFlag) || getClientVars().rightFlag || errorNumber;
}
function getPadTitle() {
    var _a, _b, _c;
    if (runtimeIsWeWorkEnv()) {
        return '***';
    }
    const title = ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.padTitle) || getClientVars().padTitle;
    if (!title) {
        return null;
    }
    return tdwEscapes(title);
}
function getGlobalPadId() {
    const domainId = getDomainId();
    const padId = getPadId();
    if (domainId && padId) {
        return `${domainId}$${padId}`;
    }
    return getClientVars().globalPadId || null;
}
function getCreatorId() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.createInfo) === null || _c === void 0 ? void 0 : _c.creatorId) || getClientVars().creatorId || null;
}
function getDomainId() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.domainId) || getClientVars().domainId || null;
}
function getPadId() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.padId) || getClientVars().padId || null;
}
function getOwnerId() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.docInfo) === null || _b === void 0 ? void 0 : _b.ownerInfo) === null || _c === void 0 ? void 0 : _c.ownerId) || getClientVars().ownerId || null;
}
function getGlobalReleaseVersion() {
    var _a;
    return ((_a = window.__DWS_INFO__) === null || _a === void 0 ? void 0 : _a.releaseVersion) || window.__globalReleaseVersion || null;
}
function getDver() {
    var _a, _b, _c, _d;
    return ((_b = (_a = getClientVars()) === null || _a === void 0 ? void 0 : _a.collab_client_vars) === null || _b === void 0 ? void 0 : _b.dver) || ((_d = (_c = getBasicClientVars()) === null || _c === void 0 ? void 0 : _c.padData) === null || _d === void 0 ? void 0 : _d.dver) || null;
}
function getApID() {
    var _a, _b;
    return ((_b = (_a = getClientVars().collab_client_vars) === null || _a === void 0 ? void 0 : _a.apid) === null || _b === void 0 ? void 0 : _b.apid) || null;
}
function getWxWorkExtPlatform() {
    if (ua.isWxWorkQt) {
        return 'wxworkQT';
    }
    return undefined;
}
function getWxWorkCEFVersion() {
    var _a;
    if (ua.isWxWorkCEF) {
        const full = ua.getWxWorkCEFVersion();
        if (typeof full === 'string') {
            const major = (_a = full.split('.')) === null || _a === void 0 ? void 0 : _a[0];
            return major;
        }
    }
    return undefined;
}
function getWeworkExtralDatas() {
    if (!runtimeIsWeWorkEnv()) {
        return {};
    }
    return {
        work_weixin_ext: JSON.stringify({
            corpid: getCorpId(),
            itemname: '',
            vid: getUidForReport(),
            logid: '',
            platform: getWxWorkExtPlatform(),
            dver: getDver(),
            wxwork_version: getVersion(),
            cef_version: getWxWorkCEFVersion(),
        }),
        work_weixin_source: '',
    };
}
function getCorpId() {
    var _a, _b, _c;
    return ((_b = (_a = getBasicClientVars()) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.corpId) || ((_c = getClientVars().userInfo) === null || _c === void 0 ? void 0 : _c.corp_id) || null;
}
function getPlatform() {
    if (ua.isHarmony) {
        return 10;
    }
    if (ua.isMobile) {
        if (ua.isAndroid) {
            return 2;
        }
        if (ua.isIOS) {
            if (ua.isIPad) {
                return 6;
            }
            return 3;
        }
        return 4;
    }
    if (ua.isMac) {
        return 5;
    }
    if (ua.isLinuxUOS) {
        return 9;
    }
    if (ua.isLinuxKylin) {
        return 8;
    }
    if (ua.isLinux) {
        return 7;
    }
    if (ua.isPCTencentDocsClient || ua.isWindows) {
        return 1;
    }
    return errorNumber;
}
function getSource1() {
    const sourceFlags = [
        [ua.isPCTencentDocsClient, 10],
        [ua.isTencentMeeting, 14],
        [ua.isTim, 2],
        [ua.isWxMiniProgram, 3],
        [ua.isWeChat, 4],
        [ua.isTencentDocsApp, 6],
        [ua.isWindowsUWP, 8],
        [ua.isQQ, 1],
        [ua.isWxWork, 9],
        [ua.isWeiYunApp, 11],
        [ua.isQQMiniProgram, 12],
        [ua.isQQDesktopDocsClient, 15],
        [ua.isElectronTencentDocsClient, 13],
        [ua.isTencentMeeting, 14],
        [ua.isQQBrowser, 5],
        [ua.isHarmonyBrowser, 5],
        [ua.isMobileQQBrowser, 5],
        [ua.isChrome, 5],
        [ua.isSafari, 5],
        [ua.isOldEdge, 5],
        [ua.isIE, 5],
        [ua.isChromiumEdge, 5],
        [ua.isFirefox, 5],
    ];
    for (let i = 0; i < sourceFlags.length; i++) {
        const [sourceFlag, value] = sourceFlags[i];
        if (sourceFlag) {
            return value;
        }
    }
    return errorNumber;
}
function getAbTest() {
    return window.ExpIdList || null;
}
function getCreatorCor() {
    const clientVars = getClientVars();
    let corpName = clientVars.userLoginCorpName;
    let corpId = clientVars.userLoginCorpId;
    if (!corpName || !corpId) {
        const userInfo = clientVars.userInfo || {};
        corpName = userInfo.corp_name;
        corpId = userInfo.corp_id;
    }
    if (corpName && corpId) {
        return runtimeIsWeWorkEnv() ? `${corpId}` : `${corpName}-${corpId}`;
    }
    return null;
}
function getDocsAppVersion() {
    if (ua.isElectronTencentDocsClient) {
        return getVersionWithName('TDAppDesktop');
    }
    if (ua.isPCTencentDocsClient) {
        return getVersionWithName('TxDocsPC');
    }
    if (ua.isTencentDocsApp) {
        return getVersionWithName('TencentDocs');
    }
}
function getVersion() {
    return ua.getWxWorkVersion();
}
function getTestEnv() {
    return getCookie('free_go_proxy') || getCookie('env_name') || getCookie('env_id') || getCookie('fd');
}
function getFrontEndExtensionFieldNames() {
    if (runtimeIsWeWorkEnv()) {
        return '';
    }
    const { userAgent } = ua;
    return JSON.stringify({
        channel: getChannel(userAgent),
        qimei: getCookie('qimei'),
        domain: clientInfo.domain,
        tenant: clientInfo.tenant,
        client: clientInfo.client,
        quadrant: getQuadrant(),
        suffix: getFileSuffix(),
    });
}
const quadrant = {
    local: 'local',
    qqbrowser_local: 'qqbrowser_local',
    drive: 'drive',
    online: 'online',
};
function getQuadrant() {
    var _a, _b, _c, _d;
    const clientValue = getURLSearchParam((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, 'client') || '';
    if (['desktop_local', 'qqclient_local', 'qq_files'].includes(clientValue)) {
        return quadrant.local;
    }
    if (clientInfo.client === 'qqbrowser_local') {
        return quadrant.qqbrowser_local;
    }
    if (getFileTypeStrForReport() === 'pdf') {
        return quadrant.drive;
    }
    if ((_d = (_c = (_b = getBasicClientVars()) === null || _b === void 0 ? void 0 : _b.docInfo) === null || _c === void 0 ? void 0 : _c.cosInfo) === null || _d === void 0 ? void 0 : _d.driveExt) {
        return quadrant.drive;
    }
    return quadrant.online;
}
function getFileSuffix() {
    var _a, _b, _c, _d, _e, _f;
    if (getQuadrant() === quadrant.local) {
        const localFilePath = getURLSearchParam((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, 'localFilePath');
        if (!localFilePath || !localFilePath.includes('.')) {
            const DEFAULT_TITLE_SUFFIX = {
                doc: '.docx',
                sheet: '.xlsx',
                slide: '.pptx',
                pdf: '.pdf',
            };
            return (_b = DEFAULT_TITLE_SUFFIX[getFileTypeStrForReport()]) !== null && _b !== void 0 ? _b : '';
        }
        return `.${localFilePath.split('.').pop()}`;
    }
    if (getFileTypeStrForReport() === 'pdf') {
        return '.pdf';
    }
    if (getQuadrant() === quadrant.drive) {
        const ext = (_f = (_e = (_d = (_c = getBasicClientVars()) === null || _c === void 0 ? void 0 : _c.docInfo) === null || _d === void 0 ? void 0 : _d.cosInfo) === null || _e === void 0 ? void 0 : _e.driveExt) !== null && _f !== void 0 ? _f : '';
        return `.${ext}`;
    }
    return '';
}

const defaultTdwData = {};
let hasOwnerId = false;
let hasUserInfo = false;
let hasDver = false;
function getDefaultTdwData$1() {
    const clientVars = getClientVars();
    if (!hasOwnerId && clientVars.ownerId) {
        hasOwnerId = true;
        resetDefaultTdwData$1();
    }
    if (!hasUserInfo && clientVars.userInfo) {
        hasUserInfo = true;
        resetDefaultTdwData$1();
    }
    if (!hasDver && getDver()) {
        hasDver = true;
        resetDefaultTdwData$1();
    }
    return defaultTdwData;
}
function resetDefaultTdwData$1(customDatas = {}) {
    Object.assign(defaultTdwData, Object.assign({ table: 'dc03111', third_appid: getApID(), uin: getUin(), uid: getUidForReport(), user_mac: getBrowserStr(), uin_type: getUinTypeForReport(), platform: getPlatform(), appid: getDocsAppVersion(), touin: getCreatorId(), isOwner: getIsOwner(), file_type: getFileTypeForReport(), id: getPadId(), source1: getSource1(), source2: '', source3: getCreatorCor() || getSource3(), obj1: getAuth(), obj2: getPadTitle(), ver1: getGlobalPadId(), ver2: getCreatorId(), ver3: getDomainId(), ver4: getOwnerId(), web_version: getGlobalReleaseVersion(), abtest: getAbTest(), frontend_ext: getFrontEndExtensionFieldNames() }, getWeworkExtralDatas()), customDatas);
    const testEnv = getTestEnv();
    if (testEnv) {
        defaultTdwData.dev_route_id = testEnv;
    }
}

const reportProxyID = '@tencent-tencent-doc-report';
function injectScript(url) {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = url;
        script.id = reportProxyID;
        script.crossOrigin = 'anonymous';
        script.setAttribute('retry-when-error', 'true');
        script.onload = () => {
            var _a;
            resolve((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK);
        };
        if (!window.TencentDocReport) {
            window.TencentDocReport = {};
        }
        if (!window.TencentDocReport.tencentDocReportInjected) {
            window.TencentDocReport.tencentDocReportInjected = true;
            window.tencentDocReportInjected = true;
            (document.head || document.body).appendChild(script);
        }
    });
}
function safeStringify(obj) {
    const seen = new Set();
    return JSON.stringify(obj, (key, value) => {
        if (isObject(value) || Array.isArray(value)) {
            if (seen.has(value)) {
                return '[Circular]';
            }
            seen.add(value);
        }
        return value;
    });
}
function isObject(obj) {
    return isType('Object', obj);
}
function isType(type, obj) {
    return Object.prototype.toString.call(obj) === `[object ${type}]`;
}

function isClassMethodType(caller) {
    return "className" in caller;
}

function init(sdkUrl) {
    var _a;
    if ((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportInjected)
        return;
    if (!window.TencentDocReport) {
        window.TencentDocReport = {
            tencentDocReportBundleURL: sdkUrl,
            tencentDocReportInjected: false,
        };
    }
    injectScript(sdkUrl)
        .then(() => {
        var _a, _b, _c, _d, _e;
        if (!window.tencentDocReportBuffers)
            return;
        for (const caller of window.tencentDocReportBuffers) {
            if (isClassMethodType(caller)) {
                ((_b = (_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK) === null || _b === void 0 ? void 0 : _b[caller.className][caller.methodName]).apply(null, JSON.parse(caller.argsStringified));
            }
            else {
                (_e = (_d = (_c = window.TencentDocReport) === null || _c === void 0 ? void 0 : _c.tencentDocReportSDK) === null || _d === void 0 ? void 0 : _d[caller.functionName]) === null || _e === void 0 ? void 0 : _e.apply(null, JSON.parse(caller.argsStringified));
            }
        }
    })
        .then(() => {
        clearBuffers();
    })
        .catch(() => {
        clearBuffers();
    });
}
function invokeClassMethod(className, methodName, args) {
    var _a, _b;
    try {
        if ((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK) {
            ((_b = window.TencentDocReport.tencentDocReportSDK) === null || _b === void 0 ? void 0 : _b[className][methodName]).apply(null, args);
            return;
        }
        pushBuffer({ className, methodName, argsStringified: safeStringify(args) });
    }
    catch (error) {
        console.error(error);
    }
}
function invokeFunction(functionName, args) {
    var _a, _b;
    try {
        if ((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK) {
            (_b = window.TencentDocReport) === null || _b === void 0 ? void 0 : _b.tencentDocReportSDK[functionName].apply(null, args);
            return;
        }
        pushBuffer({ functionName, argsStringified: safeStringify(args) });
    }
    catch (error) {
        console.error(error);
    }
}
function pushBuffer(buffer) {
    var _a;
    window.tencentDocReportBuffers = (_a = window.tencentDocReportBuffers) !== null && _a !== void 0 ? _a : [];
    window.tencentDocReportBuffers.push(buffer);
}
function clearBuffers() {
    window.tencentDocReportBuffers = [];
    delete window.tencentDocReportBuffers;
}

const isCloseAlloyReport = !!(window === null || window === void 0 ? void 0 : window.isCloseAlloyReport);
const shouldInjectSDK = () => !isCloseAlloyReport && (location.hostname.endsWith('qq.com') || (!!appDomain && !isWebOfficePrivate));

if (isInBrowser() && shouldInjectSDK()) {
    init(runtimeIsWeWorkEnv() ? ENT_SDK_BUNDLE_URL : SDK_BUNDLE_URL);
}
function tdw(...params) {
    invokeFunction('tdw', params);
}
function tdwSingle(...params) {
    invokeFunction('tdwSingle', params);
}
function reportErrorCode(...params) {
}
function webLogAndEsReport(...params) {
    invokeFunction('webLogAndEsReport', params);
}
function tipReport(...params) {
    invokeFunction('tipReport', params);
}
function webLog(...params) {
    invokeFunction('webLog', params);
}
function esLogReport(...params) {
}
const KVR = {
    init: (...params) => {
        invokeClassMethod('KVR', 'init', params);
    },
    oss: (...params) => {
        invokeClassMethod('KVR', 'oss', params);
    },
    resetDefaultOssData: (...params) => {
        invokeClassMethod('KVR', 'resetDefaultOssData', params);
    },
};
const cube = {
    init: (...params) => {
        invokeClassMethod('cube', 'initCubeReport', params);
    },
    report: (...params) => {
        invokeClassMethod('cube', 'report', params);
    },
    wecomDocs: (...params) => {
        invokeClassMethod('cube', 'wecomDocs', params);
    },
    tips: (...params) => {
        invokeClassMethod('cube', 'tips', params);
    },
    wdocs: (...params) => {
        invokeClassMethod('cube', 'wdocs', params);
    },
    retcode: (...params) => {
        invokeClassMethod('cube', 'retcode', params);
    },
    tdw: (...params) => {
        invokeClassMethod('cube', 'tdw', params);
    },
};
function zzsStatus(...params) {
    invokeFunction('zzsStatus', params);
}
function zzsValue(...params) {
    invokeFunction('zzsValue', params);
}
function idkey(...params) {
    invokeFunction('idkey', params);
}
function resetDefaultTdwData(...params) {
    invokeFunction('resetDefaultTdwData', params);
}
function getDefaultTdwData() {
    return getDefaultTdwData$1();
}
function monitor(...params) {
    invokeFunction('monitor', params);
}
function retcode(...params) {
    invokeFunction('retcode', params);
}
function retcodeEnt(...params) {
    invokeFunction('retcodeEnt', params);
}
function huatuo(...params) {
    invokeFunction('huatuo', params);
}
var reportProxy = {
    tdw,
    tdwSingle,
    reportErrorCode,
    webLogAndEsReport,
    tipReport,
    webLog,
    esLogReport,
    KVR,
    cube,
    zzsStatus,
    zzsValue,
    idkey,
    resetDefaultTdwData,
    getDefaultTdwData,
    monitor,
    retcode,
    retcodeEnt,
    huatuo,
};

export { Application, Auth, KVR, LogPadType, Page, Platform, cube, reportProxy as default, esLogReport, getAuth, getCookieUid, getCookieUin, getDefaultTdwData, getFileTypeForReport, getPlatform, getSource1, huatuo, idkey, monitor, reportErrorCode, resetDefaultTdwData, retcode, retcodeEnt, tdw, tdwSingle, tipReport, webLog, webLogAndEsReport, zzsStatus, zzsValue };
